export const DBNP_REGISTRIES_RESET_STATE = 'DBNP_REGISTRIES_RESET_STATE';
export const DBNP_REGISTRIES_CURRENT_ITEM = 'DBNP_REGISTRIES_CURRENT_ITEM';

export const DBNP_REGISTRIES_REQUEST_LOADING = 'DBNP_REGISTRIES_REQUEST_LOADING';
export const DBNP_REGISTRIES_REQUEST_SUCCESS = 'DBNP_REGISTRIES_REQUEST_SUCCESS';
export const DBNP_REGISTRIES_REQUEST_FAILED = 'DBNP_REGISTRIES_REQUEST_FAILED';

export const DBNP_REGISTRIES_CURRENT_ACTION = 'DBNP_REGISTRIES_CURRENT_ACTION';
export const DBNP_REGISTRIES_RESET_ACTION = 'DBNP_REGISTRIES_RESET_ACTION';